import { render, staticRenderFns } from "./ERegistrationPublicRegisterView.vue?vue&type=template&id=47f7694e&scoped=true&"
import script from "./ERegistrationPublicRegisterView.vue?vue&type=script&lang=js&"
export * from "./ERegistrationPublicRegisterView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f7694e",
  null
  
)

export default component.exports